/* eslint arrow-body-style: 0 */
import { frontendURL } from '../../../../helper/URLHelper';

const SettingsContent = () => import('../Wrapper.vue');
const InboxHome = () => import('./Index.vue');
const Settings = () => import('./Settings.vue');
const InboxChannel = () => import('./InboxChannels.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/inboxes'),
      component: SettingsContent,
      props: (route) => {
        const showBackButton = route.name !== 'settings_inbox_list';
        return {
          headerTitle: 'SETTINGS_CENTER.INBOX_CHANNELS',
          headerButtonText: 'SETTINGS.INBOXES.NEW_INBOX',
          icon: 'mail-inbox-all',
          keepAlive: false,
          newButtonRoutes: ['settings_inbox_list'],
          showBackButton,
        };
      },
      children: [
        {
          path: '',
          name: 'settings_inbox',
          redirect: 'list',
        },
        {
          path: 'list',
          name: 'settings_inbox_list',
          component: InboxHome,
          roles: ['administrator'],
        },
        {
          path: 'new',
          name: 'settings_inbox_new',
          component: InboxChannel,
          roles: ['administrator'],
        },
        {
          path: 'new/:inbox_id/finish',
          name: 'settings_inbox_finish',
          component: InboxChannel,
          roles: ['administrator'],
        },
        {
          path: 'new/:inbox_id/agents',
          name: 'settings_inboxes_add_agents',
          roles: ['administrator'],
          component: InboxChannel,
        },
        {
          path: 'new/:sub_page',
          name: 'settings_inboxes_page_channel',
          component: InboxChannel,
          roles: ['administrator'],
          beforeEnter: (to) =>
            ['email', 'whatsapp', 'telegram', 'instagram'].includes(
              to.params.sub_page
            )
              ? true
              : {
                  name: 'settings_inbox_new',
                  params: { accountId: to.params.accountId },
                },
        },
        {
          path: ':inboxId',
          name: 'settings_inbox_show',
          component: Settings,
          roles: ['administrator'],
        },
      ],
    },
  ],
};
